import React, { forwardRef, useState } from 'react';
import { EyeIcon, EyeOffIcon } from '../../../helpers/icons';

export const PasswordInputField = forwardRef(
  (
    { placeholder, label, error, extraClasses = '', height = '36', ...rest },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);
    const text = error || label || '';
    return (
      <div className="w--full d--flex flex--column">
        {text && (
          <label
            className={`label--control font--sm font--500 m-b--sm  ${
              error ? 'text--danger' : 'text--black'
            }`}
          >
            {text}
          </label>
        )}
        <div className="w--full inputIcon position--relative">
          <input
            {...rest}
            type={showPassword ? 'text' : 'password'}
            ref={ref}
            placeholder={placeholder}
            className={`form--control w--full h-min--${height} radius--sm p-l--md ${extraClasses} ${error ? 'border-full--danger' : 'border-full--black-200'}`}
            style={{ paddingRight: '2.5rem', textOverflow: 'ellipsis' }}
          />
          <button
            type="button"
            tabIndex={-1}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            className="d--flex align-items--center justify-content--center position--absolute top--0 bottom--0 right--0 c--pointer bg--transparent"
            style={{ width: '2.25rem', border: 'none' }}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <EyeIcon width={20} /> : <EyeOffIcon width={20} />}
          </button>
        </div>
      </div>
    );
  },
);
